module.exports = __webpack_public_path__ + "media/customizations/pecansquarelife/logo-new-c04de21913de59f6db7f91431281bb37.png";